// extracted by mini-css-extract-plugin
export default {"NextButtonWrapper":"NextButton_NextButtonWrapper__0U4G4"};